import { render, staticRenderFns } from "./TreatmentRecorder.vue?vue&type=template&id=343c146e&"
import script from "./TreatmentRecorder.vue?vue&type=script&lang=ts&"
export * from "./TreatmentRecorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports